// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"edb2227e","618":"edb2227e"}[chunkId] + ".chunk.css";
};